import http from 'hub-http/clients/apiClient';
import { convertCategoriesToOldFormat, convertPrimaryCategoriesToOldFormat, getShouldCallSCPEndpoints, getTranslatedKBIdForLanguage } from '../migration-handler/singleton/migrationHandler';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-categories';
const MULTILANG_API_BASE = '/knowledge-content/v1/knowledge-category-translations/category-organization';
const NEW_MULTILANG_API_BASE = 'knowledge-content/v1/knowledge-category-organization/knowledge-base';
const SCP_API_CATEGORY_ORGANIZATION_BASE = '/knowledge-content/v2/category-organization';
const SCP_API_CATEGORY_ORGANIZATION_BASE_BUFFER = '/knowledge-content/v2/category-organization/buffer';
const SCP_API_CATEGORY = 'knowledge-content/v2/category';
export default class KnowledgeCategoriesApi {
  static setOrdering(parentCategoryId, orderedChildIds) {
    return http.put(`${API_BASE}/order/${parentCategoryId}`, {
      data: orderedChildIds,
      timeout: 30000
    });
  }
  static delete(categoryId, knowledgeBaseId) {
    const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
    if (!isOnSCP) {
      const url = `${API_BASE}/${categoryId}`;
      return http.delete(url, {
        timeout: 30000
      });
    }
    const url = `${SCP_API_CATEGORY}/${categoryId}`;
    return http.delete(url, {
      timeout: 30000
    });
  }
  static update(categoryId, data) {
    const url = `${API_BASE}/${categoryId}`;
    return http.put(url, {
      data,
      timeout: 30000
    });
  }
}
KnowledgeCategoriesApi.getCategoryOrganization = makeSimpleQuickFetchWrapper('get-category-organization', () => http.get(`${API_BASE}/category-organization`));
KnowledgeCategoriesApi.getTranslatedCategoryOrganizationWithArticles = makeSimpleQuickFetchWrapper('get-translated-category-organization', (knowledgeBaseId, language) => {
  const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${MULTILANG_API_BASE}`, {
      query: {
        language,
        knowledgeBaseId,
        timeout: 30000
      }
    });
  }
  return http.get(`${SCP_API_CATEGORY_ORGANIZATION_BASE}/with-articles/knowledge-base/${knowledgeBaseId}`, {
    query: {
      language
    }
  }).then(response => ({
    categories: convertCategoriesToOldFormat(response.categories),
    primaryLanguage: response.primaryLanguage,
    requestedLanguage: response.requestedLanguage
  })).catch(res => {
    throw new Error(`KnowledgeCategoriesApi.getTranslatedCategoryOrganizationWithArticles failed with code ${res.response.status}.res: ${JSON.stringify(res.response.data)}`);
  });
});
KnowledgeCategoriesApi.getTranslatedCategoryOrganization = makeSimpleQuickFetchWrapper('get-translated-category-organization', (knowledgeBaseId, language) => {
  const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${NEW_MULTILANG_API_BASE}/${knowledgeBaseId}/buffer/parent-categories`, {
      query: {
        language
      },
      timeout: 30000
    });
  }
  const kbIdToFetch = language ? getTranslatedKBIdForLanguage(knowledgeBaseId, language) : knowledgeBaseId;
  return http.get(`${SCP_API_CATEGORY_ORGANIZATION_BASE_BUFFER}/knowledge-base/${knowledgeBaseId}/parent-categories`)
  //If kbIdToFetch is a varinat KBId we need to fetch translated categories
  .then(response => {
    const primaryCategories = convertPrimaryCategoriesToOldFormat(response.categories);
    if (kbIdToFetch !== knowledgeBaseId) {
      return http.get(`${SCP_API_CATEGORY_ORGANIZATION_BASE_BUFFER}/knowledge-base/${kbIdToFetch}/parent-categories`).then(variantResp => {
        const variantCategories = convertPrimaryCategoriesToOldFormat(variantResp.categories);
        const unTranslatedCategories = primaryCategories.filter(category => language && !category.translatedToLanguages.includes(language));
        return {
          categories: variantCategories.concat(unTranslatedCategories).sort((a, b) => (a.position || 0) - (b.position || 0)),
          primaryLanguage: variantResp.primaryLanguage,
          requestedLanguage: variantResp.requestedLanguage
        };
      });
    }
    return {
      categories: primaryCategories,
      primaryLanguage: response.primaryLanguage,
      requestedLanguage: response.requestedLanguage
    };
  }).catch(res => {
    throw new Error(`KnowledgeCategoriesApi.getTranslatedCategoryOrganization failed with code ${res.response.status}.res: ${JSON.stringify(res.response.data)}`);
  });
});
KnowledgeCategoriesApi.getHydratedTranslatedCategory = makeSimpleQuickFetchWrapper('get-translated-category-organization', (knowledgeBaseId, language, categoryId) => {
  const isOnSCP = getShouldCallSCPEndpoints(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${NEW_MULTILANG_API_BASE}/${knowledgeBaseId}/buffer/parent-category/${categoryId}/subcategories`, {
      query: {
        language
      },
      timeout: 30000
    });
  }
  const kbIdToFetch = language ? getTranslatedKBIdForLanguage(knowledgeBaseId, language) : knowledgeBaseId;
  return http.get(`${SCP_API_CATEGORY_ORGANIZATION_BASE_BUFFER}/with-articles/knowledge-base/${kbIdToFetch}/parent-category/${categoryId}`).then(response => ({
    categories: convertCategoriesToOldFormat(response.categories),
    primaryLanguage: response.primaryLanguage,
    requestedLanguage: response.requestedLanguage
  })).catch(res => {
    throw new Error(`KnowledgeCategoriesApi.getHydratedTranslatedCategory failed with code ${res.response.status}.res: ${JSON.stringify(res.response.data)}`);
  });
});